export default __webpack_public_path__ + "static/codemymobile_website_2_blue_white_-Django-ea9d9a86daff34b7e7a5d063bf90c586.jpg";